import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Spin, Space } from 'antd';
import { ProfileButton, ProfileIcon } from '@med-fe/ui';
import { getUserEmail, getUserDataLoading } from '../../../store/user/user-reducer';
import { CloseIcon } from '../../doctor-panel/DoctorPanel';
import { StyledDrawer } from './styled';

const ProfilePanel = ({ user, onSignOut }) => {
  const dispatch = useDispatch();
  const userEmail = useSelector(getUserEmail);
  const loading = useSelector(getUserDataLoading);
  const [open, setOpen] = useState<boolean>(false);

  // If you have other profile-loading behavior, keep/use it here.
  useEffect(() => {
    // keep behaviour that depends on `open` or `user` if needed
    // currently no fetchEmailGroups / fetchUserEmailGroups calls here (UI only removal)
  }, [user, open]);

  return (
    <>
      <ProfileButton
        type='primary'
        shape='circle'
        icon={<ProfileIcon src={'./icons/avatar.svg'} alt='avatar' />}
        onClick={() => setOpen(true)}
      />
      <StyledDrawer
        visible={open}
        closable={false}
        onClose={() => {
          setOpen(false);
        }}
        title={user?.name || ''}
        extra={
          <div>
            <Space>
              {/* Uncomment if you want Sign out link inside drawer */}
              {/* <Button type='link' onClick={onSignOut}>Sign out</Button> */}
              <CloseIcon onClick={() => setOpen(false)} />
            </Space>
          </div>
        }
        // no footer related to email subscription
      >
        <Spin spinning={loading}>{/* Remaining profile UI goes here. Example: show email or other settings */}</Spin>
      </StyledDrawer>
    </>
  );
};

export default ProfilePanel;
